export default __webpack_public_path__ + "static/media/Award_Statue_Character_Bronze.256.82c416c2.png";